/* eslint-disable no-console */
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import {
  AccountDetails,
  AccountNotesModel,
  ClientCustodyContact,
  TransportDetails,
} from '../models/account-details.model'

const ACCOUNT_DETAILS_HOST = `helios-account-details`
const ACCOUNT_DETAILS_URL = `${ACCOUNT_DETAILS_HOST}/{accountId}`
const TRANSPORT_DETAILS_URL = `${ACCOUNT_DETAILS_HOST}/{accountId}/dataFeeds`
const CUSTODY_CONTACTS_URL = `${ACCOUNT_DETAILS_HOST}/{accountId}/custodyContacts`
const SLEEVE_ACCOUNT_VALIDATION_URL = `${ACCOUNT_DETAILS_HOST}/{accountId}/sleeveAccountValidation`

const ACCOUNT_NOTES_URL_V2 = `${ACCOUNT_DETAILS_HOST}/notes`
const ACCOUNT_NOTES_POST_URL_V2 = `${ACCOUNT_DETAILS_HOST}/notes/create`
const ACCOUNT_NOTES_UPDATE_URL_V2 = `${ACCOUNT_DETAILS_HOST}/notes/update`

@Injectable({
  providedIn: 'root',
})
export class AccountDetailsService {
  constructor(private readonly httpClient: HttpClient) {}

  getAccountDetails(accountId?: string): Observable<AccountDetails> {
    if (!accountId) return of()
    return this.httpClient.get<AccountDetails>(
      ACCOUNT_DETAILS_URL.replace('{accountId}', accountId),
    )
  }

  getTransportDetails(accountId?: string): Observable<TransportDetails[]> {
    if (!accountId) return of()
    return this.httpClient.get<TransportDetails[]>(
      TRANSPORT_DETAILS_URL.replace('{accountId}', accountId),
    )
  }

  getCustodyContacts(accountId?: string): Observable<ClientCustodyContact[]> {
    if (!accountId) return of()
    const options = {
      params: new HttpParams().set('dataSourceId', 1),
    }
    return this.httpClient.get<ClientCustodyContact[]>(
      CUSTODY_CONTACTS_URL.replace('{accountId}', accountId),
      options,
    )
  }

  getAccountNotesV2(accountIds: number[]): Observable<AccountNotesModel> {
    return this.httpClient.post<AccountNotesModel>(ACCOUNT_NOTES_URL_V2, {
      accountIds: accountIds,
    })
  }

  updateNotes(noteIds: number[], note: string) {
    return this.httpClient.put(ACCOUNT_NOTES_UPDATE_URL_V2, {
      note: note,
      noteIds: noteIds,
    })
  }

  addNotes(note: string, accountIds: number[]) {
    return this.httpClient.post(ACCOUNT_NOTES_POST_URL_V2, {
      note: note,
      accountIds: accountIds,
    })
  }

  getSleeveAccountValidation(
    reconDate: string,
    accountId: string,
  ): Observable<string[]> {
    return this.httpClient.get<string[]>(
      SLEEVE_ACCOUNT_VALIDATION_URL.replace('{accountId}', accountId),
      {
        params: new HttpParams().set('reconDate', reconDate),
      },
    )
  }
}
